import BillComponent from 'POSComponents/BillComponent'
import React from 'react'

function POS() {
  return (
    <div className='POS'>
        <BillComponent/>  
    </div>
  )
}

export default POS